// WAS THIS SIGN-OFF FORCED, AND WHAT DID THE GATE SAY.
//
// Signing off an activity is gated - no open issue on it, every child
// carrying a sign-off date signed first, so BIM signs off after its
// disciplines. The gate can be overridden, and until 2026-09-26 the
// only trace was one line in an activity log: the schedule showed an
// ORDINARY sign-off, and the project manager - the person who looks at
// the schedule - could not tell the difference.
//
// utils/activitySignOff now records it on the row, including WHAT THE
// GATE REFUSED, because tomorrow the issues are resolved and the
// children are signed and nothing could reconstruct why.
//
// ONE SENTENCE, THREE RENDERERS. The detail panel, the bar's tooltip
// and the printed star all read from here: a tooltip that says "signed
// off" while the panel says it was forced is exactly the disagreement
// this codebase keeps designing out.

/** Null when the sign-off was ordinary - including when the row predates
 *  the provenance, which is most of them. Never guesses. */
export function forcedSignOff(item) {
  const p = item && item.signOffProvenance;
  if (!p || p.source !== "forced") return null;
  const r = p.refusedBecause || {};
  const reasons = [];
  const open = Number(r.openIssues) || 0;
  const kids = Array.isArray(r.unsignedChildren) ? r.unsignedChildren.length : 0;
  if (open) reasons.push(`${open} open issue${open === 1 ? "" : "s"}`);
  if (kids) reasons.push(`${kids} child activit${kids === 1 ? "y" : "ies"} not signed off`);
  return {
    by: (p.forcedBy && p.forcedBy.name) || "",
    at: p.forcedAt || null,
    via: p.via || "",
    reasons,
    // The short form the three renderers print. A forced sign-off with
    // no recorded reason still says it was overridden: the word is the
    // point, and losing it because the detail is missing would put us
    // back where we started.
    short: reasons.length ? `overridden — ${reasons.join(", ")}` : "overridden",
  };
}

export default forcedSignOff;
